// 主题：默认深色，<html data-theme="light"> 切浅色。
import { useSyncExternalStore } from "react";

export type Theme = "dark" | "light";

export function getTheme(): Theme {
  return document.documentElement.dataset.theme === "light" ? "light" : "dark";
}

export function setTheme(t: Theme) {
  document.documentElement.dataset.theme = t;
  try {
    localStorage.setItem("cs2c.theme", t);
  } catch {
    /* ignore */
  }
}

/** 订阅 <html data-theme> 的变化，任何地方切换主题都会触发重渲染。 */
function subscribe(cb: () => void) {
  const mo = new MutationObserver(cb);
  mo.observe(document.documentElement, { attributes: true, attributeFilter: ["data-theme"] });
  return () => mo.disconnect();
}

export function useTheme(): Theme {
  return useSyncExternalStore(subscribe, getTheme);
}
